export const prepareFormValues = (values) => {
  const newValues = {};

  for (let key in values) {
    newValues[key] = values[key].trim();
  }

  return newValues;
};
